<template>
  <div class="mycodebody">
    <div class="backbtn">
      <backbtn></backbtn>
    </div>
    <div class="downpicbox" :style="{display:showdownpicbox}">
      <div id="vanshowp"></div>
    </div>
    <div class="downpicboxbg" v-if="showdownpic">
      <p class="closeicon" @click="closevanshow">
        <van-icon size="28px" name="cross" color="#fff" />
      </p>
      <p class="downtext">请长按图片选择保存图片到手机相册</p>
    </div>
    <div class="mycodebanner">
      <swiper :options="swiperOption">
        <swiper-slide>
          <div class="cartlistbox">
            <img src="../../assets/images/mpm_1.jpg" />
            <div class="cartsmbox02">
              <div class="cartsmtitle">用于画册印刷</div>
              <div class="cartsmcon">
                <p class="infotext">
                  <span class="bigtext">使用场景：</span>
                  公司画册、宣传单张上印上您的专 属名片小程序码，您的客户微信扫描后直接联 系您并将名片信息同步到手机
                </p>
              </div>
              <div class="cartsize">
                <p class="bigtext">
                  尺寸：
                  <span>230mm*230mm</span>
                </p>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="cartlistbox">
            <div class="mycartcode">
              <div class="mycarttitlebox">
                <dl>
                  <dt v-if="cartdata.avatar_url">
                    <img :src="cartdata.avatar_url" />
                  </dt>
                  <dt v-else>
                    <img :src="morentx" />
                  </dt>
                  <dd>
                    <p class="username" v-if="cartdata.name">{{cartdata.name}}</p>
                    <p class="username" v-else>用户456578</p>
                    <p v-if="cartdata.job_title">{{cartdata.job_title}}</p>
                    <div v-else>
                      <p v-if="isown" class="dwspbox" @click="handleUpdateCart">
                        <span>职称待完善</span>
                        <van-icon name="arrow" />
                      </p>
                      <p v-else class="dwspbox">
                        <span>职称待完善</span>
                      </p>
                    </div>
                    <p v-if="companyName">{{companyNames}}</p>
                    <div v-else>
                      <p v-if="isown" class="dwspbox" @click="handleUpdateCart">
                        <span>公司信息待完善</span>
                        <van-icon name="arrow" />
                      </p>
                      <p v-else class="dwspbox">
                        <span>公司信息待完善</span>
                      </p>
                    </div>
                  </dd>
                </dl>
                <div class="myewm">
                  <img :src="ewm2" />
                </div>
              </div>
            </div>
            <div class="cartsmbox02">
              <div class="cartsmcon">
                <p class="infotext">使用智能二维码追踪技术，访客扫描进入您的名片，AI雷达实时对访客进行分析，帮助您精准获客；纸质名片、海报、网站公众号均可使用</p>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="cartlistbox">
            <img src="../../assets/images/mpm_2.jpg" />
            <div class="cartsmbox02">
              <div class="cartsmtitle">用于一系列VI</div>
              <div class="cartsmcon">
                <p class="infotext">
                  <span class="bigtext">使用场景：</span>
                  手提袋、纸杯、工牌等一系列上印您的名片专属小程序码，您的客户微信扫描后直接联系您并将名片信息同步至手机
                </p>
              </div>
              <div class="cartsize">
                <p class="bigtext">
                  尺寸：
                  <span>200mm*200mm</span>
                </p>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="cartlistbox">
            <img src="../../assets/images/mpm_3.jpg" />
            <div class="cartsmbox02">
              <div class="cartsmtitle">用于海报印刷</div>
              <div class="cartsmcon">
                <p class="infotext">
                  <span class="bigtext">使用场景：</span>
                  易拉宝、海报等宣传物料上印上您的名片专属小程序码，您的客户通过扫码后直接联系您并将名片信息同步到手机
                </p>
              </div>
              <div class="cartsize">
                <p class="bigtext">
                  尺寸：
                  <span>230mm*230mm</span>
                </p>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="cartlistbox">
            <img src="../../assets/images/mpm_4.jpg" />
            <div class="cartsmbox02">
              <div class="cartsmtitle">用于名片印刷</div>
              <div class="cartsmcon">
                <p class="infotext">
                  <span class="bigtext">使用场景：</span>
                  将您的名片专属小程序码印在纸质名片上，您的客户微信扫码就可将名片信息同步到手机
                </p>
              </div>
              <div class="cartsize">
                <p class="bigtext">
                  尺寸：
                  <span>80mm*80mm</span>
                </p>
              </div>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
    <div id="addImage" style="display:none;height:0; position: absolute; top:0;left:0; overflow:hidden;"></div>
    <div class="downbox">
      <div ref="thehtml">
        <div class="cartlistbox cartlistbox02">
          <!-- 头部头像 -->
          <div class="cu-list menu-avatar min-toptxbox">
            <div class="cu-item" style="height:4.54rem">
              <div class="cu-avatar round lg touxiang" v-if="cartdata.avatar_url">
                <img :src="cartdata.avatar_url" />
              </div>
              <div class="cu-avatar round lg touxiang" v-else>
                <img src="../../assets/images/cart-tx.png" />
              </div>
              <div class="content">
                <div class="text-grey">
                  <p class="text-grey-name" v-if="cartdata.name">{{cartdata.name}}</p>
                  <p class="text-grey-name" v-else>用户456578</p>
                </div>
                <div class="text-gray">
                  <p v-if="cartdata.job_title">{{cartdata.job_title}}</p>
                  <p v-else>职称待完善</p>
                </div>
                <div class="text-gray flex text-grey-company">
                  <p v-if="companyName">{{companyName}}</p>
                  <p v-else>公司信息待完善</p>
                </div>
              </div>
            </div>
          </div>
          <!--二维码-->
          <div class="ewmabox">
            <img :src="cartdata.applets_qrcode" />
          </div>
          <div class="cartsmbox">
            <text class="infotext">使用智能二维码追踪技术，访客扫描进入您的名片，AI雷达实时对访客进行分析，帮助您精准获客；纸质名片、海报、网站公众号均可使用q</text>
          </div>
        </div>
      </div>
    </div>
    <div class="cartcodebtn" v-if="generatorevent">
      <button @click="generatorImage" class="savetobtn">保存到手机</button>
    </div>
    <div class="cartcodebtn" v-else>
      <button @click="saveImage" class="savetobtn">保存到手机</button>
    </div>
    <screen-capture ref="sc" :html="html"></screen-capture>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { Toast } from "vant";
import backbtn from "../public/backbtn";
import { getmycart } from "../../api/api";
import navbar from "../public/navbar.vue";
import html2canvas from "html2canvas";
import ScreenCapture from "../public/ScreenCapture";
export default {
  name: "cartcode",
  components: {
    swiper,
    swiperSlide,
    navbar,
    ScreenCapture,
    backbtn
  },
  props: {
    msg: String
  },
  data () {
    return {
      html: null,
      morentx: require("../../assets/images/moren.jpg"),
      ewm: require("../../assets/images/qrcode.jpg"),
      ewm2: "",
      companyName: '',
      swiperOption: {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 15,
        initialSlide: 1,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      titlename: "名片码",
      cartdata: [],
      showdownpic: false,
      showdownpicbox: "block",
      generatorevent: true,
      imgsrc: "",
      isown: this.$route.query.isown
    };
  },
  mounted () {
    //获取id请求数据
    this.html = this.$refs.thehtml;
  },
  created () {
    document.title = this.titlename;
    Toast.loading({
      mask: true,
      message: "加载中..."
    });
    let api_uid = this.$route.query.id;
    let that = this;
    if (localStorage.getItem("cartdata")) {
      let cartdata = localStorage.getItem("cartdata");
      that.cartdata = JSON.parse(cartdata);
      that.ewm2 = JSON.parse(cartdata).applets_qrcode_url;
      that.companyName = JSON.parse(cartdata).company_info.company_name;
    }

    getmycart(api_uid)
      .then(res => {
        if (res.data.code == 200) {
          that.cartdata = res.data.data;
          that.ewm2 = res.data.data.applets_qrcode_url;
          that.companyName = res.data.data.company_info.company_name;
          localStorage.setItem("cartdata", JSON.stringify(res.data.data));
          Toast.clear();
        } else {
          Toast.fail("加载失败！");
        }
      })
      .catch(err => {
      });
  },
  methods: {
    handleUpdateCart (e) {
      this.$router.push({
        name: "cartform",
        query: {
          userid: this.$route.query.id
        }
      });
    },
    showPopup () {
      this.showmodel = true;
    },
    closevanshow () {
      this.showdownpicbox = "none";
      this.showdownpic = false;
    },
    saveImage () {
      this.showdownpicbox = "block";
      this.showdownpic = true;
    },
    generatorImage () {
      let that = this;

      const toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "海报下载中..."
      });

      let second = 3;
      const timer = setInterval(() => {
        second--;
        if (second) {
          toast.message = `海报下载中...`;
        } else {
          clearInterval(timer);
          Toast.clear();
        }
      }, 1000);

      this.$refs.sc.capture();
      let addImage = document.getElementById("addImage");

      setTimeout(download, 3000);

      function download () {
        let ocanvas = document.getElementsByTagName("canvas")[0];
        html2canvas(ocanvas).then(canvas => {
          that.showdownpic = true;
          that.showdownpicbox = true;
          addImage.append(ocanvas);
          let link = document.createElement("img");
          link.src = canvas.toDataURL();
          link.style.display = "block";
          link.style.width = "100%";
          var vanshowp = document.getElementById("vanshowp");
          vanshowp.appendChild(link);
          that.generatorevent = false;
          setTimeout(downloadafter, 1500);
        });
      }

      function downloadafter () {
        Toast.success("请长按图片选择保存图片到相册");
      }
    },
    gotocartform () {
      this.$router.push({
        name: "cartform"
      });
    }
  },
  activated () {
    if (localStorage.getItem("cartdata")) {
      let cartdata = localStorage.getItem("cartdata");
      that.cartdata = JSON.parse(cartdata);
      that.ewm2 = JSON.parse(cartdata).applets_qrcode;
      that.companyName = JSON.parse(cartdata).company_info.company_name;
    }
  },
  beforeDestroy () {
    localStorage.removeItem("cartdata");
  }
};
</script>

<style>
@import "../../assets/css/reset.css";
.closeicon {
  text-align: right;
  padding-right: 1rem;
  padding-top: 0.8rem;
}
.downpicbox {
  position: fixed;
  width: 80%;
  left: 10%;
  top: 3rem;
  z-index: 10;
}
.downpicbox #vanshowp img {
  width: 100%;
}
.backbtn {
  position: fixed;
  left: 1rem;
  top: 1rem;
  z-index: 3;
}
.downpicboxbg .downtext {
  color: #fff;
  text-align: center;
  font-size: 0.75rem;
  position: absolute;
  bottom: 1rem;
  width: 100%;
}
.downpicboxbg {
  position: fixed;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9;
}
.mycodebanner {
  padding-top: 0.5rem;
}
.mycodebanner .swiper-slide {
  width: 70%;
  margin-right: 0;
}
.navbar {
  position: fixed;
  z-index: 10;
}
.mycodebanner .swiper-slide img {
  width: 100%;
}
.mycodebanner .swiper-button-prev {
  outline: none;
  background: url("../../assets/images/mine_icon_left.png") no-repeat;
  background-size: 100%;
  width: 1.8rem;
  height: 1.8rem;
  left: 1.8rem;
}
.mycodebanner .swiper-button-next {
  outline: none;
  background: url("../../assets/images/mine_icon_right.png") no-repeat;
  background-size: 100%;
  width: 1.8rem;
  height: 1.8rem;
  right: 1.8rem;
}

.mycodebanner .cartlistbox {
  height: 23rem;
  background: #fff;
  box-shadow: 0px 0px 9px #ddd;
}
.mycodebanner .swiper-container {
  overflow: inherit;
}
.dwspbox {
  clear: both;
  padding-top: 0.1rem;
  overflow: hidden;
}
.dwspbox span {
  float: left;
}
.dwspbox i {
  font-style: normal;
  padding-left: 0.1rem;
  padding-top: 0.2rem;
  float: left;
}
.mycodebanner .cartlistbox .cartsmbox02 .cartsmtitle {
  font-size: 0.81rem;
  line-height: 0.86rem;
  display: block;
  color: rgba(51, 51, 51, 0.8);
  font-weight: bold;
}

.mycodebanner .cartlistbox .cartsmbox02 .cartsmcon {
  padding-top: 0.6rem;
  font-size: 0.7rem;
  height: 3.467rem;
  margin: 0;
  color: rgba(102, 102, 102, 0.8);
}

.mycodebanner .cartlistbox .cartsmbox02 .cartsize {
  font-size: 0.7rem;
  padding-top: 0.9rem;
  color: rgba(102, 102, 102, 0.8);
}

.mycodebanner .cartlistbox .bigtext {
  font-size: 0.7rem;
  color: rgb(51, 51, 51);
}

.mycodebanner .cartlistbox .infotext {
  font-size: 0.7rem;
  color: rgba(102, 102, 102, 0.7);
}

.mycodebanner .cartlistbox .cartsmbox02 .cartsize .bigtext span {
  font-size: 0.7rem;
  color: rgba(102, 102, 102, 0.7);
  display: inline-block;
}

.mycodebanner .cartlistbox .cartsmbox02 {
  padding-left: 0.8108108108108109rem;
  padding-right: 0.7297297297297297rem;
  padding-top: 0.8108108108108109rem;
}

.cartcodebtn {
  text-align: center;
  padding-top: 1.3rem;
}
.cartcodebtn .savetobtn {
  height: 2.4324324324324325rem;
  font-size: 0.7567567567567568rem;
  color: #fff;
  line-height: 2.4324324324324325rem;
  border-radius: 1.3513513513513513rem;
  background: linear-gradient(to right, rgb(255, 189, 10), rgb(248, 218, 91));
  width: 80%;
  border: none;
  margin-bottom: 9rem;
}

.mycodebody {
  background: #f8f8f8;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.downbox {
  width: 70%;
  margin: 0 auto;
  background: #fff;
  position: absolute;
  top: 6.9rem;
  left: 15%;
  z-index: -5;
}
.downbox .cartlistbox02 {
  padding-left: 0.8rem;
  padding-right: 0.8rem;
}
.downbox .cartlistbox02 .ewmabox {
  width: 100%;
  height: 9.72972972972973rem;
  padding-top: 0.40540540540540543rem;
  text-align: center;
}
.downbox .cartlistbox02 .ewmabox img {
  width: 9.054054054054054rem;

  margin: 0 auto;
  display: block;
}
.downbox .cartlistbox02 .cartsmbox {
  padding-left: 0.8108108108108109rem;
  padding-right: 0.7297297297297297rem;
  color: rgb(102, 102, 102);
  font-size: 0.7027027027027027rem;
}
.downbox .min-toptxbox {
  padding-top: 1.2162162162162162rem;
}
.downbox .min-toptxbox .cu-item {
  background: none;
  color: #fff;
}
.downbox .min-toptxbox .cu-item .cu-avatar.lg {
  width: 3.2432432432432434rem;
  height: 3.2432432432432434rem;
}
.downbox .min-toptxbox .cu-item .content .text-grey {
  color: #fff;
}
.downbox .touxiang {
  float: left;
}
.downbox .touxiang img {
  width: 3.24rem;
  border-radius: 50%;
}
.downbox .cu-item .content {
  float: left;
  background: #fff;
  padding-left: 0.5rem;
}
.downbox .cu-item .content .text-gray p {
  font-size: 0.7rem;
  color: rgb(102, 102, 102);
}
.downbox .cu-item .content .text-grey .text-grey-name {
  font-size: 0.8648648648648649rem;
  color: rgb(51, 51, 51);
  font-weight: bold;
}
.mycartcode .mycarttitlebox {
  overflow: hidden;
}
.mycartcode .mycarttitlebox dl {
  padding-top: 1.8918918918918919rem;
  padding-left: 0.9rem;
}
.mycartcode .mycarttitlebox dl dt {
  width: 3.2432432432432434rem;
  height: 3.2432432432432434rem;
  float: left;
}
.mycartcode .mycarttitlebox dl dt img {
  width: 3.2432432432432434rem;
  height: 3.2432432432432434rem;
  border-radius: 50%;
}
.mycartcode .mycarttitlebox dl dd {
  float: left;
  width: 8.5rem;
  padding-left: 0.6rem;
}
.mycartcode .mycarttitlebox dl dd p {
  font-size: 0.7027027027027027rem;
  color: #999;
}
.mycartcode .mycarttitlebox dl dd .username {
  color: #333;
  font-size: 0.8648648648648649rem;
}
.mycartcode .myewm {
  clear: both;
  text-align: center;
  padding-top: 1.7567567567567568rem;
  padding-bottom: 0.6rem;
  height: 7.702702702702703rem;
}
.mycartcode .myewm img {
  width: 7.702702702702703rem;
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/cartcode.vue